var _desc, _defs, _rect, _text, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreDriverWhatsappInterfaceGuidedChatMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 620,
    height: 1140,
    viewBox: "0 0 620 1140",
    role: "img",
    "aria-labelledby": titleId,
    "data-revision": "vehicle-dashboard-v2",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "mobileTitle"
  }, "FleetCore guided WhatsApp vehicle sign-in workflow on mobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "mobileTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "mobileDesc"
  }, "A mobile WhatsApp-style conversation between the FleetCore Controller and a driver completing vehicle sign-in with side-view vehicle and dashboard photographs.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mobileScreenClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 182,
    width: 464,
    height: 874,
    rx: 36
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "mobileChatPattern",
    width: 72,
    height: 72,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18c8-8 18-5 18 4s-10 13-18 7M48 11l8 8-8 8M17 52h12m-6-6v12M50 48c7 0 11 5 11 11",
    fill: "none",
    stroke: "#60766B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.08
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mobileVehiclePhotoClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 580,
    width: 118,
    height: 64,
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mobileDashboardPhotoClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 776,
    width: 118,
    height: 64,
    rx: 8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobileVehicleSky",
    x1: 353,
    y1: 580,
    x2: 353,
    y2: 626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DDE8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C0A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobileVehicleGround",
    x1: 353,
    y1: 619,
    x2: 353,
    y2: 644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B99469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6E50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobileVehicleBody",
    x1: 353,
    y1: 596,
    x2: 353,
    y2: 632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EFF2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobileDashboardSurface",
    x1: 353,
    y1: 776,
    x2: 353,
    y2: 840,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4B55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#202D35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11191E"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "mobilePhoneShadow",
    x: "-20%",
    y: "-10%",
    width: "140%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 18,
    floodColor: "#07152A",
    floodOpacity: 0.18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 619,
    height: 1139,
    rx: 42,
    fill: "#FFFFFF",
    stroke: "#D5E3F2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 57,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 1.4
  }, "DRIVER WORKFLOWS IN ONE FAMILIAR CHAT")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 83,
    width: 166,
    height: 52,
    rx: 15,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 114h21v-7l-3-5H67l-4 5v7m0-7h15m-14 7v3m14-3v3",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 97,
    y: 115,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 800
  }, "Sign in"), /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 83,
    width: 166,
    height: 52,
    rx: 15,
    fill: "#FFFFFF",
    stroke: "#D5E3F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 103,
    width: 18,
    height: 13,
    rx: 3,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 109.5,
    r: 3.5,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 103l2-3h6l2 3",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 284,
    y: 115,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 800
  }, "Sign out"), /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 83,
    width: 166,
    height: 52,
    rx: 15,
    fill: "#FFFFFF",
    stroke: "#D5E3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 117v-16h11v16m-13 0h15m-10-12h6v4h-6m8-5 5 4v8c0 3 4 3 4 0v-7",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 471,
    y: 115,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 800
  }, "Refuel"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#mobilePhoneShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 164,
    width: 492,
    height: 910,
    rx: 46,
    fill: "#17211D",
    stroke: "#07120D",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mobileScreenClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 182,
    width: 464,
    height: 874,
    fill: "#EFEAE2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 300,
    width: 464,
    height: 672,
    fill: "url(#mobileChatPattern)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 182,
    width: 464,
    height: 38,
    fill: "#075E54"
  }), /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 207,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 700
  }, "06:03"), /*#__PURE__*/React.createElement("path", {
    d: "M473 204h3m3-3h3m3-3h3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 199c5-5 11-5 16 0m-13 3c3-3 7-3 10 0",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 195,
    width: 15,
    height: 8,
    rx: 2,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533,
    y: 197,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 197,
    width: 10,
    height: 4,
    rx: 1,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 220,
    width: 464,
    height: 80,
    fill: "#075E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 261h-11m0 0 6-6m-6 6 6 6",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 260,
    r: 23,
    fill: "#128C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 251c-1 6 4 13 11 15l4-4-5-3-2 3c-3-2-5-4-7-7l3-3-3-4z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 255,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 800
  }, "FleetCore Controller"), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 276,
    fill: "#CFF6E1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 600
  }, "online \xB7 vehicle sign-in"), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 252,
    width: 15,
    height: 17,
    rx: 3,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 257l8-5v17l-8-5",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511,
    cy: 251,
    r: 2.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511,
    cy: 260,
    r: 2.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511,
    cy: 269,
    r: 2.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 312,
    width: 112,
    height: 22,
    rx: 11,
    fill: "#FFFFFF",
    fillOpacity: 0.82
  }), /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 327,
    textAnchor: "middle",
    fill: "#66776E",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: 0.8
  }, "TODAY \xB7 06:03"), /*#__PURE__*/React.createElement("path", {
    d: "M98 352L88 346L98 368Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 342,
    width: 318,
    height: 66,
    rx: 12,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 114,
    y: 366,
    fill: "#17251D",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Morning, Thabo."), /*#__PURE__*/React.createElement("text", {
    x: 114,
    y: 388,
    fill: "#17251D",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Ready to sign in to FC-217?"), /*#__PURE__*/React.createElement("text", {
    x: 401,
    y: 397,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8.5
  }, "06:03"), /*#__PURE__*/React.createElement("path", {
    d: "M520 430L530 424L520 446Z",
    fill: "#D9FDD3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 420,
    width: 166,
    height: 44,
    rx: 12,
    fill: "#D9FDD3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 447,
    fill: "#17251D",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Yes, start"), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 455,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8.5
  }, "06:03 ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#1689C4"
  }, "\u2713\u2713")), /*#__PURE__*/React.createElement("path", {
    d: "M98 488L88 482L98 504Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 478,
    width: 362,
    height: 78,
    rx: 12,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 511,
    r: 15,
    fill: "#E7F3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 506,
    width: 16,
    height: 11,
    rx: 2,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 511.5,
    r: 3,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 506l2-3h6l2 3",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 504,
    fill: "#17251D",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13.5,
    fontWeight: 800
  }, "Step 1 of 2 \xB7 Side photo"), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 527,
    fill: "#385045",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12
  }, "Stand back and capture the full"), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 545,
    fill: "#385045",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12
  }, "side view of the vehicle."), /*#__PURE__*/React.createElement("text", {
    x: 445,
    y: 547,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8.5
  }, "06:04"), /*#__PURE__*/React.createElement("path", {
    d: "M520 578L530 572L520 594Z",
    fill: "#D9FDD3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 568,
    width: 238,
    height: 94,
    rx: 12,
    fill: "#D9FDD3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mobileVehiclePhotoClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 580,
    width: 118,
    height: 64,
    fill: "url(#mobileVehicleSky)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 591,
    r: 5,
    fill: "#F9D890",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 614l18-10 17 7 18-12 22 12 17-8 26 12v14H294z",
    fill: "#9CA99C",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 580v34m34-34v34m-38-30h43",
    fill: "none",
    stroke: "#6F7D78",
    strokeWidth: 1,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 584h43l8 6",
    fill: "none",
    stroke: "#6F7D78",
    strokeWidth: 1.2,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 619,
    width: 118,
    height: 25,
    fill: "url(#mobileVehicleGround)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 628c24-4 45-3 65 1s37 3 53 0",
    fill: "none",
    stroke: "#D8BE98",
    strokeWidth: 1.2,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 353,
    cy: 634,
    rx: 50,
    ry: 4.5,
    fill: "#4C4035",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 619l9-2 8-7h7l5-11q1.5-3 5-3h15q4 0 7 4l9 12h31v5l9 4v10H299z",
    fill: "url(#mobileVehicleBody)",
    stroke: "#596A73",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 600h16q3 0 5 3l7 9h-34z",
    fill: "#87ADBF",
    stroke: "#596A73",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 600v12M324 613h37v17M345 615v14",
    fill: "none",
    stroke: "#7A8990",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 612v-9h28v9M362 612h33M369 606v5m9-5v5m9-5v5",
    fill: "none",
    stroke: "#596A73",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339,
    y: 591.5,
    width: 8,
    height: 4,
    rx: 2,
    fill: "#F39122",
    stroke: "#BE6D11",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327 596h31",
    stroke: "#485860",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 598l4 14",
    stroke: "#485860",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 607l-5-2-3 3h6",
    fill: "#53636B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 620,
    width: 8,
    height: 5,
    rx: 1,
    fill: "#E7F2F5",
    stroke: "#596A73",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 617,
    width: 4,
    height: 6,
    rx: 1,
    fill: "#D94D3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 620h58",
    stroke: "#F2B544",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 623h58",
    stroke: "#286CA8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 617,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#53636B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 631h94",
    stroke: "#68777D",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 631a9 9 0 0118 0M377 631a9 9 0 0118 0",
    fill: "#25323A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 631,
    r: 8.5,
    fill: "#202A30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 631,
    r: 4.2,
    fill: "#A8B2B7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 631,
    r: 1.7,
    fill: "#4C5B63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 631,
    r: 8.5,
    fill: "#202A30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 631,
    r: 4.2,
    fill: "#A8B2B7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 631,
    r: 1.7,
    fill: "#4C5B63"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 625,
    width: 5,
    height: 3,
    rx: 1,
    fill: "#39464D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 626,
    width: 6,
    height: 3,
    rx: 1,
    fill: "#39464D"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 580,
    width: 118,
    height: 64,
    rx: 8,
    fill: "none",
    stroke: "#9EB5BF",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 424,
    y: 598,
    fill: "#17251D",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 800
  }, "Photo sent"), /*#__PURE__*/React.createElement("text", {
    x: 424,
    y: 618,
    fill: "#385045",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11
  }, "Side view"), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 650,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8.5
  }, "06:05 ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#1689C4"
  }, "\u2713\u2713")), /*#__PURE__*/React.createElement("path", {
    d: "M98 684L88 678L98 700Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 674,
    width: 362,
    height: 78,
    rx: 12,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 707,
    r: 15,
    fill: "#FFF0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 711a10 10 0 0118 0M124 703v7l5-3",
    fill: "none",
    stroke: "#E48A1A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 700,
    fill: "#17251D",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13.5,
    fontWeight: 800
  }, "Step 2 of 2 \xB7 Dashboard"), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 723,
    fill: "#385045",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12
  }, "Photograph the dashboard with the"), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 741,
    fill: "#385045",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12
  }, "odometer reading clearly visible."), /*#__PURE__*/React.createElement("text", {
    x: 445,
    y: 743,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8.5
  }, "06:05"), /*#__PURE__*/React.createElement("path", {
    d: "M520 774L530 768L520 790Z",
    fill: "#D9FDD3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 764,
    width: 238,
    height: 94,
    rx: 12,
    fill: "#D9FDD3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mobileDashboardPhotoClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 776,
    width: 118,
    height: 64,
    fill: "url(#mobileDashboardSurface)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 792q59-22 118 0v48H294z",
    fill: "#1A252C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 833v-25q0-19 20-23h66q20 4 20 23v25z",
    fill: "#0D151A",
    stroke: "#607580",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 787q49-13 98 0",
    fill: "none",
    stroke: "#8FA6B4",
    strokeWidth: 1.2,
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 807,
    r: 17.5,
    fill: "#101A20",
    stroke: "#91A9B5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 807,
    r: 13.2,
    fill: "none",
    stroke: "#43545D",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 816l-3 3m5-14-4-1m8-7-2-4m10 3 1-4m6 8 4-2m0 11 4 1",
    stroke: "#DDE8EC",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 807l8-10",
    stroke: "#F6A33A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 807,
    r: 2,
    fill: "#D8E2E6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 807,
    r: 17.5,
    fill: "#101A20",
    stroke: "#91A9B5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 807,
    r: 13.2,
    fill: "none",
    stroke: "#43545D",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 816l-3 3m5-14-4-1m8-7-2-4m10 3 1-4m6 8 4-2m0 11 4 1",
    stroke: "#DDE8EC",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 807l-7-11",
    stroke: "#F6A33A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 807,
    r: 2,
    fill: "#D8E2E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 793,
    width: 34,
    height: 27,
    rx: 3,
    fill: "#071014",
    stroke: "#70838C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 353,
    y: 801,
    textAnchor: "middle",
    fill: "#7EDFB0",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 4.7,
    fontWeight: 800
  }, "ODOMETER"), /*#__PURE__*/React.createElement("text", {
    x: 353,
    y: 811,
    textAnchor: "middle",
    fill: "#D7FFE9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 7.2,
    fontWeight: 800
  }, "184 263"), /*#__PURE__*/React.createElement("text", {
    x: 353,
    y: 817,
    textAnchor: "middle",
    fill: "#7EDFB0",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 4.4,
    fontWeight: 700
  }, "km"), /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 827,
    r: 1.7,
    fill: "#51CF88"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 827,
    r: 1.7,
    fill: "#F0B44B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 827,
    r: 1.7,
    fill: "#E75E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 840a27 27 0 0154 0",
    fill: "none",
    stroke: "#536873",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 820v20m-12-4h24",
    stroke: "#536873",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 838,
    r: 7,
    fill: "#26353D",
    stroke: "#778A93",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 780l28 0-20 42",
    fill: "#FFFFFF",
    opacity: 0.05
  })), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 776,
    width: 118,
    height: 64,
    rx: 8,
    fill: "none",
    stroke: "#607580",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 424,
    y: 794,
    fill: "#17251D",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 800
  }, "Photo sent"), /*#__PURE__*/React.createElement("text", {
    x: 424,
    y: 814,
    fill: "#385045",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11
  }, "Odometer"), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 846,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8.5
  }, "06:06 ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#1689C4"
  }, "\u2713\u2713")), /*#__PURE__*/React.createElement("path", {
    d: "M98 880L88 874L98 896Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 870,
    width: 394,
    height: 88,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#7CE1AC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 914,
    r: 22,
    fill: "#C8F3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 914l6 6 13-15",
    fill: "none",
    stroke: "#07916D",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 901,
    fill: "#07916D",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0.6
  }, "SIGN-IN COMPLETE"), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 925,
    fill: "#17251D",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "FC-217 \xB7 184,263 km"), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 945,
    fill: "#385045",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11.5
  }, "Both photos verified and filed"), /*#__PURE__*/React.createElement("text", {
    x: 477,
    y: 948,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8.5
  }, "06:06"), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 978,
    width: 382,
    height: 52,
    rx: 26,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 1004,
    r: 10,
    fill: "none",
    stroke: "#819188",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 1001,
    r: 1.2,
    fill: "#819188"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 1001,
    r: 1.2,
    fill: "#819188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 1007c3 3 6 3 9 0",
    fill: "none",
    stroke: "#819188",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 1009,
    fill: "#87938D",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13
  }, "Message"), /*#__PURE__*/React.createElement("path", {
    d: "M428 997l12 12m-6-18-16 16c-4 4 2 10 6 6l14-14",
    fill: "none",
    stroke: "#819188",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511,
    cy: 1004,
    r: 26,
    fill: "#00A884"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507,
    y: 992,
    width: 8,
    height: 16,
    rx: 4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 1005c0 10 16 10 16 0m-8 8v6",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 182,
    width: 464,
    height: 874,
    rx: 36,
    fill: "none",
    stroke: "#07120D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 191,
    width: 108,
    height: 20,
    rx: 10,
    fill: "#17211D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreDriverWhatsappInterfaceGuidedChatMobile);
export default __webpack_public_path__ + "static/media/fleetcore-driver-whatsapp-interface-guided-chat-mobile.abc046b547f6e0cad1f6c828c19ff3f8.svg";
export { ForwardRef as ReactComponent };